"use strict";

$.widget("fotobook.calendarProjectDate", $.fotobook.monthpicker,{
    _create: function(){
        this._super();
        this.createLayout();
    },

    createLayout: function(){
        var $this = this;
        this.monthpicker = $(".month-selection-alt");

        this.monthpicker.MonthPicker($.extend($this.options, {
            "OnAfterChooseMonth": function() {
                var newMonth = $(this).val();
                $(this).trigger("monthpicker-monthselected", newMonth);
                $(".monthpicker-selection-input").val(newMonth);
            },
        }));
    },
});

$(document).on(Fotobook.events.EDITOR_TOOLBAR_OPENED, function() {
    // todo выделить в виджет редактора контейнера
    $(".editorToolbar").find(".month-selection-alt").calendarProjectDate({});
});
